/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontRichiesteIdTipiComunicazioneTipo =
  (typeof GetFrontRichiesteIdTipiComunicazioneTipo)[keyof typeof GetFrontRichiesteIdTipiComunicazioneTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontRichiesteIdTipiComunicazioneTipo = {
  INVIABILE: 'INVIABILE',
  RICERCABILE: 'RICERCABILE',
  RICEVIBILE: 'RICEVIBILE',
} as const;
